import { makeAutoObservable } from 'mobx';
import { PaymentMethodViewModel, UserViewModel } from '../core/backend/models';
import { Address, ICoordinates } from '../core/types';

class UserStore {
  user: UserViewModel | undefined = undefined;
  paymentMethods: PaymentMethodViewModel[] = [];
  coords: ICoordinates;
  fullAddress: string;
  addressFields: Address;

  constructor() {
    makeAutoObservable(this);
  }
  saveUserToStore = (user: UserViewModel | undefined) => {
    this.user = user;
  };

  savePaymentMethods = (paymentMethods: PaymentMethodViewModel[]) => {
    this.paymentMethods = paymentMethods;
  };

  saveAddress = (
    fullAddress: string,
    addressFields: Address,
    coords: ICoordinates
  ) => {
    this.fullAddress = fullAddress;
    this.addressFields = addressFields;
    this.coords = coords;
  };
}

export default UserStore;
